import { useDispatch, useSelector } from "react-redux";
import * as StoreTypes from "../../DataTypes/storeTypes";
import * as Actions from "../../Actions/actions";
import { Button, Typography } from "@powerdiary/components-library/lib";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

export const Header = () => {
    const {
        common: { currentStep, isBusy },
    } = useSelector((state: StoreTypes.IStore) => state);
    const dispatch = useDispatch();

    let title = null;

    switch (currentStep) {
        case StoreTypes.Step.Location: {
            title = "Select a location";
            break;
        }

        case StoreTypes.Step.Service: {
            title = "Select a service";
            break;
        }

        case StoreTypes.Step.Provider: {
            title = "Select a provider";
            break;
        }
        case StoreTypes.Step.When: {
            title = "Select a date and time";
            break;
        }

        case StoreTypes.Step.Confirmation: {
            title = (
                <div className="d-flex justify-content-between align-items-center">
                    <Button
                        variant="outlined"
                        size="extraSmall"
                        onClick={() => dispatch(Actions.moveBack())}
                        disabled={isBusy}
                        startIcon={<FontAwesomeIcon icon={faArrowLeft} />}
                    >
                        Back
                    </Button>

                    <Typography variant="paragraphExtraLargeBold" sx={{ fontSize: "1.8rem" }}>
                        Please Review and Confirm
                    </Typography>

                    <Button
                        variant="outlined"
                        size="extraSmall"
                        onClick={() => dispatch(Actions.requestCancel(true))}
                        disabled={isBusy}
                    >
                        Cancel
                    </Button>
                </div>
            );
            break;
        }
    }

    if (!title) return null;

    return (
        <div className="row">
            <div className="col-12 col-lg-11 ml-lg-auto mr-lg-auto text-center mb10">
                <h3 className="question mb10">{title}</h3>
            </div>
        </div>
    );
};
